import actionTypes from "../../actionTypes";

export const setClassesOrSeriesAction = (data) => ({
  type: actionTypes.adminTypes.groupManagement.GET_CLASSES_OR_SERIES,
  payload: data,
});

export const setDeleteManadatedClassAction = (data) => ({
  type: actionTypes.adminTypes.groupManagement.DELETE_MANADATED_CLASS,
  payload: data,
});

export const setManageUsersCountAction = (data) => ({
  type: actionTypes.adminTypes.groupManagement.MANAGE_USERS_COUNT,
  payload: data,
});

export const setManageSubgroupsCountAction = (data) => ({
  type: actionTypes.adminTypes.groupManagement.MANAGE_SUBGROUPS_COUNT,
  payload: data,
});
